import { BusinessError, businessErrorFactory } from '../../../../../../common/business-error';

const RESEND_USER_INVITATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your user invitation resend request. Please try again. If the problem still persists, contact with support.';

const USER_INVITATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your user invitation request. Please try again. If the problem still persists, contact with support.';

const USER_DELETE_INVITATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your user invitation delete request. Please try again. If the problem still persists, contact with support.';

export const resendUserInvitationBusinessError = (): BusinessError =>
  businessErrorFactory({
    message: RESEND_USER_INVITATION_UNEXPECTED_ERROR,
    severity: 'error'
  });

export const userInvitationBusinessError = (): BusinessError =>
  businessErrorFactory({
    message: USER_INVITATION_UNEXPECTED_ERROR,
    severity: 'error'
  });

export const userDeleteInvitationBusinessError = (): BusinessError =>
  businessErrorFactory({
    message: USER_DELETE_INVITATION_UNEXPECTED_ERROR,
    severity: 'error'
  });
